import { Bell, BellRing, Smartphone } from 'lucide-react'
import { useAdminPush } from '@/contexts/AdminPushContext'
import { Button } from '@/components/ui/Button'
import { pushBlockMessage } from '@/lib/pushPlatform'

export function AdminPushPrompt() {
  const { enabled, loading, enablePush, canEnablePush, platform } = useAdminPush()

  if (enabled) return null

  if (!canEnablePush && platform.reason) {
    return (
      <div className="mb-4 rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-900/90">
        <div className="flex items-start gap-3">
          <Smartphone className="h-5 w-5 shrink-0 mt-0.5 text-amber-700" />
          <div>
            <p className="font-medium text-zinc-800">Push alerts unavailable here</p>
            <p className="mt-1 text-xs leading-relaxed text-zinc-600">
              {pushBlockMessage(platform.reason)}
            </p>
            {platform.inAppAlertsAvailable ? (
              <p className="mt-2 text-xs text-zinc-500">
                While the admin panel stays open in this tab, you will still get
                on-screen toast alerts for new orders.
              </p>
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  if (!canEnablePush) return null

  if (typeof Notification !== 'undefined' && Notification.permission === 'denied') {
    return (
      <div className="mb-4 rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-200/90">
        Notifications are blocked in your browser. Allow them in site settings to
        get instant order alerts.
      </div>
    )
  }

  return (
    <div className="mb-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-xl border border-gold-500/25 bg-gold-500/5 px-4 py-3">
      <div className="flex items-start gap-3">
        <Bell className="h-5 w-5 text-gold-700 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-medium text-zinc-800">
            Get instant alerts for new orders
          </p>
          <p className="text-xs text-zinc-500 mt-0.5">
            Enable push notifications on this device (works when the admin panel
            is open or in the background).
          </p>
          {platform.isStandalonePwa ? (
            <p className="text-xs text-emerald-700 mt-1">
              Home Screen app detected — you can enable push on this device.
            </p>
          ) : null}
        </div>
      </div>
      <Button
        size="sm"
        loading={loading}
        onClick={() => void enablePush()}
        className="shrink-0"
      >
        <BellRing className="h-4 w-4" /> Enable alerts
      </Button>
    </div>
  )
}
